import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { addItemsToCart, removeItemsFromCart } from '../../actions/cartAction';
import { getDiscount } from '../../utils/functions';
import { saveForLater } from '../../actions/saveForLaterAction';
import { Link } from 'react-router-dom';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useLang, uiText } from '../../utils/i18n';

const CartItem = ({ product, name, seller, price, cuttedPrice, image, stock, quantity, inCart, offerLine }) => {

    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { lang } = useLang();

    const increaseQuantity = (id, quantity) => {
        // No stock cap anymore — inventory counts aren't tracked.
        const newQty = quantity + 1;
        dispatch(addItemsToCart(id, newQty));
    }

    const decreaseQuantity = (id, quantity) => {
        const newQty = quantity - 1;
        if (quantity <= 1) return;
        dispatch(addItemsToCart(id, newQty));
    }
    
    const removeCartItem = (id) => {
        dispatch(removeItemsFromCart(id));
        enqueueSnackbar(uiText('productRemovedFromCart', lang), { variant: "success" });
    }

    const saveForLaterHandler = (id) => {
        dispatch(saveForLater(id));
        removeCartItem(id);
        enqueueSnackbar(uiText('savedForLaterToast', lang), { variant: "success" });
    }

    return (
        <div className="flex flex-col gap-3 py-5 pl-2 sm:pl-6 border-b overflow-hidden" key={product}>

            <Link to={`/product/${product}`} className="flex flex-col sm:flex-row gap-5 items-stretch w-full group">
                {/* <!-- product image --> */}
                <div className="w-full sm:w-1/6 h-28 flex-shrink-0">
                    <img draggable="false" className="h-full w-full object-contain" src={image} alt={name} />
                </div>
                {/* <!-- product image --> */}

                {/* <!-- description --> */}
                <div className="flex flex-col sm:gap-5 w-full pr-6">
                    {/* <!-- product title --> */}
                    <div className="flex flex-col sm:flex-row justify-between items-start pr-5 gap-1 sm:gap-0">
                        <div className="flex flex-col gap-0.5 sm:w-3/5">
                            <p className="group-hover:text-primary-blue">{name.length > 42 ? `${name.substring(0, 42)}...` : name}</p>
                            <span className="text-sm text-gray-500">{uiText('sellerLabel', lang)} {seller}</span>
                        </div>

                        <div className="flex flex-col sm:gap-2">
                            
                        </div>

                    </div>
                    {/* <!-- product title --> */}

                    {/* <!-- price desc --> */}
                    <div className="flex items-baseline gap-2 text-xl font-medium">
                        <span>HK${(offerLine?.discountedTotal ?? (price * quantity)).toLocaleString()}</span>
                        <span className="text-sm text-gray-500 line-through font-normal">HK${(cuttedPrice * quantity).toLocaleString()}</span>
                        <span className="text-sm text-primary-green">{getDiscount(price, cuttedPrice)}%&nbsp;{uiText('offLabel', lang)}</span>
                    </div>
                    {offerLine?.appliedOffer && (
                        <p className="text-xs text-primary-green font-medium flex items-center gap-1">
                            <LocalOfferIcon sx={{ fontSize: "14px" }} /> {offerLine.appliedOffer.description} {uiText('appliedLabel', lang)}
                        </p>
                    )}
                    {/* <!-- price desc --> */}

                </div>
                {/* <!-- description --> */}
            </Link>

            {/* <!-- save for later --> */}
            <div className="flex justify-between pr-4 sm:pr-0 sm:justify-start sm:gap-6">
                {/* <!-- quantity --> */}
                {inCart ? (
                    <div className="flex gap-1 items-center">
                        <span onClick={() => decreaseQuantity(product, quantity)} className="w-7 h-7 text-3xl font-light bg-gray-50 rounded-full border flex items-center justify-center cursor-pointer"><p>-</p></span>
                        <input className="w-11 border outline-none text-center rounded-sm py-0.5 text-gray-700 font-medium text-sm qtyInput" value={quantity} disabled />
                        <span onClick={() => increaseQuantity(product, quantity)} className="w-7 h-7 text-xl font-light bg-gray-50 rounded-full border flex items-center justify-center cursor-pointer">+</span>
                    </div>
                ) : (
                    <p className="text-sm text-gray-600 font-medium">{uiText('qtyLabel', lang)} {quantity}</p>
                )}
                {/* <!-- quantity --> */}
                {inCart && (
                    <>
                    <button onClick={() => saveForLaterHandler(product)} className="sm:ml-4 font-medium hover:text-primary-blue">{uiText('saveForLaterBtn', lang)}</button>
                    <button onClick={() => removeCartItem(product)} className="font-medium hover:text-red-600">{uiText('removeBtn', lang)}</button>
                    </>
                )}
            </div>
            {/* <!-- save for later --> */}

        </div>
    );
};

export default CartItem;
